<template>
    <div class="editform">
        <Form ref="pInfo"
            :model="pInfo"
            :rules="ruleValidate"
            :label-width="70">
            <Row :gutter="20">
                <Col span="12">
                <Row>
                    <Col span="24">
                    <FormItem label="姓名"
                        prop="nickname">
                        <Input v-model="pInfo.nickname"
                            :readonly="readonly"
                            :maxlength="32"></Input>
                    </FormItem>
                    </Col>
                    <Col span="24">
                    <FormItem label="手机号"
                        prop="phone">
                        <Input v-model="pInfo.phone"
                            :readonly="readonly"
                            :maxlength="32"></Input>
                    </FormItem>
                    </Col>
                </Row>
                </Col>
                <Col span="12">
                <FormItem label="形象照"
                    prop="avatar">
                    <preview-upload v-model="pInfo.avatar"
                        :showName="false"
                        :readonly="readonly"></preview-upload>
                </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                <FormItem label="岗位"
                    prop="rids">
                    <form-lookup v-model="pInfo.rids"
                        placeholder="请选择岗位"
                        :readonly="readonly"
                        title="选择岗位"
                        :modalHeight="480"
                        :modalWidth="480"
                        :options="orgOptions">
                        <select-org></select-org>
                    </form-lookup>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="项目"
                    prop="aids">
                    <Select v-model="aids"
                        multiple
                        filterable
                        transfer
                        :readonly="readonly">
                        <Option v-for="(item, index) in projList"
                            :value="item.id"
                            :key="index">{{item.projName}}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="启用"
                    prop="enabled">
                    <i-switch v-model="pInfo.enabled"
                        :readonly="readonly"
                        size="large"
                        :true-value="1"
                        :false-value="0">
                        <span slot="open">启用</span>
                        <span slot="close">禁用</span>
                    </i-switch>
                </FormItem>
                </Col>
            </Row>
            <Row>
                <FormItem label="说明"
                    prop="remark">
                    <Input type="textarea"
                        :readonly="readonly"
                        v-model="pInfo.remark"
                        placeholder="0/1000"
                        :rows="4"
                        :maxlength="1000"></Input>
                </FormItem>
            </Row>
        </Form>
    </div>
</template>
<script>
import { userView, userAdd, userUpdate, roleList } from "@/api/user-manager"
import { projList } from "@/api/proj-manager"

import PreviewUpload from '_c/preview-upload'
import { ymd } from "_u/helper"
import SelectOrg from "./select-org"

export default {
    name: "UserForm",
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: {
        SelectOrg,
        PreviewUpload
    },
    inject: {
        $modal: {
            default: null
        }
    },
    data() {
        var data = {
            loading: false,
            pInfo: {
                id: "",
                nickname: "",
                avatar: "",
                phone: "",
                ver: "",
                enabled: "",
                remark: "",
                rids: "",
                aids: ""
            },
            userList: [],
            modalHeight: 600,
            modalWidth: 1000,
            orgOptions: [],
            channelList: [],
            projList: []
        }

        data.ruleValidate = {
            nickname: [{
                required: true,
                message: "姓名必填"
            }],
            phone: [{
                required: true,
                message: "手机号必填"
            }, ],
            rids: [{
                required: true,
                message: "岗位必填"
            }]
        }
        return data
    },

    computed: {
        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly() {
            return this.loading || !this.canSave
        },

        aids: {
            get() {
                return this.pInfo.aids ? this.pInfo.aids.split(",") : []
            },

            set(val) {
                this.pInfo.aids = val.join(",")
            }
        },
    },
    methods: {
        fetch() {
            // 修改
            if (this.id) {
                return userView(this.id)
            } else {
                // 默认启用
                this.pInfo.enabled = 1
                return Promise.resolve()
            }
        }
    },
    mounted() {
        var $pInfo = this.$refs.pInfo,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        this.loading = true
        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        this.$modal.onBtnClick("confirm", (next, options) => {
            $pInfo.validate(valid => {
                if (valid) {
                    var formData = Object.assign({}, this.pInfo)

                    if (this.id) {
                        userUpdate(formData)
                            .then(
                                res =>
                                this.$Message.success(
                                    this.$t("tips.update.success")
                                ),
                                err => (options.closeModal = false)
                            )
                            .then(res => next())
                    } else {
                        delete formData.ver
                        userAdd(formData)
                            .then(
                                res =>
                                this.$Message.success(
                                    this.$t("tips.add.success")
                                ),
                                err => (options.closeModal = false)
                            )
                            .then(res => next())
                    }
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter(next => {
            Promise.all([
                    this.fetch(),
                    roleList(),
                    projList(1, 9999)
                ])
                .then(args => {
                    var [user, role, proj] = args
                    this.orgOptions = role.data.list

                    if (user) {
                        var userData = user.data

                        Object.keys(this.pInfo).forEach(
                            name => (this.pInfo[name] = userData[name])
                        )
                    }
                    this.projList = proj.data.page.list || []
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
